export const DAY_WEEK_TYPE = {
  DAY: "day",
  WEEK: "week",
};
